import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Invite } from '@models/businesses';
import { FirestoreRepo } from '@repos/firestore-repo.service';
import { collections } from '@models/collections';

/**
 * Multi-Business Service.
 * Service for gathering all invites a User is a part of.
 */
@Injectable()
export class UserInvitesService extends FirestoreRepo<Invite, null> {
	constructor() {
		super(() => collections.business_invites);
	}

	private userInvitesSource = new BehaviorSubject<Invite[]>([]);

	public setUserInvites(invites: Invite[]) {
		this.userInvitesSource.next(invites);
	}

	public get userInvites$(): Observable<Invite[]> {
		return this.userInvitesSource.asObservable();
	}
}
